import ContentHeading from "@/components/content-heading";
import React from "react";
import {useTranslation} from "react-i18next";
import {articleWrapper} from "./style";
import ArticleItems from "@/components/pages/media/articles/article-items";

const Articles = () => {
    const {t} = useTranslation();
    return <section className={articleWrapper}>
        <ContentHeading h={"h3"}
                        className={"justify-center"}
                        backdropPosition={"left-4"}
                        fontSize={"mobile:text-3xl tablet:text-5xl"}
                        background={"bg-primary bg-opacity-40"}>
            {t("media.article-section.heading")}
        </ContentHeading>
        <ArticleItems/>
    </section>
}

export default Articles